import { actionCreator } from '../helpers';

const createAction = actionCreator('PAGE');

export const fetchPage = createAction<void>('FETCH_PAGE');
export const fetchPageSuccess = createAction<any>('FETCH_PAGE_SUCCESS');
